import Vue from 'vue';
import Config from '@/config';
import Features from '@/config/features.json';

Vue.directive('feature', {
  inserted(element, binding, virtualNode) {
    if (Config.ENV === 'development') return;

    const isFeatureEnabled = Features[binding.value];
    if (isFeatureEnabled === undefined) {
      throw new Error('The feature is not exist on configuration file. ');
    } else if (isFeatureEnabled === false) {
      virtualNode.elm.parentElement.removeChild(virtualNode.elm);
    }
  }
});
